/**
 * Endpoint 9 — POST logs/error (research/04 §5.6; REQ-API-9). Fire-and-forget
 * error-log transport over jQuery's ajax — XHR, not fetch (transport choice
 * is observable, REQ-API-3), body verbatim, no .fail handler. DIV-004: the
 * bundled jQuery, not the theme's. DIV-043: via cpcAjax (compat/jquery-ajax.ts).
 */
import { appState } from "../state/app-state";
import { cpcAjax } from "../compat/jquery-ajax";

export function globalHelper_ReportError(err: any, msg1: any = ""): void {
  var sourceUrl = window.location.href;
  var errMsg = JSON.stringify(err, Object.getOwnPropertyNames(err));
  errMsg = errMsg + ", Msg1 = " + msg1 + ", SourceUrl = " + sourceUrl;

  // DIV-043: cpcAjax, not $.ajax — immune to a theme app patching the shared
  // jQuery's .ajax (see compat/jquery-ajax.ts).
  cpcAjax({
    // DIV-002: `type:` not `method:` — see checkout/add-to-cart.ts.
    type: "POST",
    url: appState.baseCalculatorNewApiUrl + "logs/error",
    data: JSON.stringify({
      calculatorId: appState.cpc_calculatorId,
      productId: appState.cpc_productId,
      errorMessage: errMsg,
    }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).done(function () {});
}
